import { DataScope } from 'scrivito'

export const dataScopeHasMore = (
  dataScope: DataScope,
  transform: object,
  limit: number,
): boolean => {
  try {
    return (
      dataScope.transform({ ...transform, limit: limit + 1 }).take().length >
      limit
    )
  } catch {
    return false
  }
}
